// 该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'


import MonitoringServices from '../view/monitor';
import InternetThings from '../view/iot';
import mobileExperience from '../view/mobileExperience'
import monitorMannage from '../view/monitorMannage'
import projectMannage from '../view/projectMannage'
import dashboardMannage from '../view/dashboardMannage'



import { setToken, getToken, getUrlParam, setCookie, getCookie } from '../utils/auth'
import axios from 'axios';
import apis from '../utils/apis';
import config from '../utils/config';

// 创建一个路由器
const router = new VueRouter({
    routes: [
        {
            name: 'jiancefuwu',
            path: '/monitor',
            component: MonitoringServices,
            // 页面标题
            meta: { title: '监测服务' }
        },
        {
            name: 'wulianwang',
            path: '/iot',
            component: InternetThings,
            meta: { title: '物联网' }
        },
        {
            name: 'monitorMannage',
            path: '/monitorMannage',
            component: monitorMannage,
            meta: { title: '监测物管理' }
        },
        {
            name: 'projectMannage',
            path: '/projectMannage',
            component: projectMannage,
            meta: { title: '项目管理' }
        },
        {
            name: 'dashboardMannage',
            path: '/dashboardMannage',
            component: dashboardMannage,
            meta: { title: '可视化大屏' }
        },
        {
            name: 'mobileExperience',
            path: '/mobileExperience',
            component: mobileExperience,
            meta: { title: '介绍页' }
        },
        {
            path: '/',
            redirect: '/monitor', //设置默认指向的路径
            name: '监测服务'
        }
    ],
    scrollBehavior: () => ({ y: 0 }),
})

// 全局前置路由守卫--每次路由切换之前被调用
router.beforeEach((to, from, next) => {
    // 未接单点登录，传参方式跳转
    var token = getToken();

    if (token) {
        // // 若token正确
        // var ssoBase = apis.tokenValidate;
        // axios.get(ssoBase + "?token=" + token).then(            
        //     response => {
        //         var validToken = false;
        //         if (response.status === 200) {    
        //             var result = response.data;                 
        //             if(result.code===200){
        //                 validToken = true;
        //             }
        //         }
        //         if(!validToken){
        //             console.log('token校验失败',token);
        //             window.location.href = apis.login;
        //         }
        //     },
        //     error => {
        //         console.log('token校验失败接口调用失败:' + error.message);
        //         window.location.href = apis.login;
        //     }
        // );        
        next();
    }
    else {
        var redirect = getCookie(config.redirectKey);
        var logoutUrl = apis.logout;
        if (redirect) {
            logoutUrl += "&redirect=" + redirect;
            window.location.href = logoutUrl;
            return
        }
        window.location.href = apis.login;
    }
})

// // 全局后置路由守卫---初始化的时候被调用，每次路由切换之后被调用
// router.afterEach((to, from) => {
//     console.log('后置', to, from)
//     document.title = to.meta.title || 
// })
export default router




// WEBPACK FOOTER //
// ./src/router/index.js